import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mode: 'light',
  isFriendListPanelOpen: false,
  isNotificationSidebarOpen: false,
  isCartOpen: false,
  isWishlistOpen: false,
  isAvatarDropdownOpen: false,  
  isWalletSidebarOpen: false,
  isConsoleModalOpen: false,
  isTopLevelDropdownOpen: false,
};

function closeOverlayPanels(state) {
  state.isFriendListPanelOpen = false;
  state.isNotificationSidebarOpen = false;
  state.isCartOpen = false;
  state.isWishlistOpen = false;
  state.isAvatarDropdownOpen = false;
  state.isWalletSidebarOpen = false;
  state.isConsoleModalOpen = false;
  state.isTopLevelDropdownOpen = false;
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    toggleTopLevelDropdown: (state) => {
      const nextIsOpen = !state.isTopLevelDropdownOpen;
      closeOverlayPanels(state);
      state.isTopLevelDropdownOpen = nextIsOpen;
    },
    setTopLevelDropdownOpen: (state, action) => {
      closeOverlayPanels(state);
      state.isTopLevelDropdownOpen = Boolean(action.payload);
    },
    toggleFriendListPanel: (state) => {
      const nextIsOpen = !state.isFriendListPanelOpen;
      closeOverlayPanels(state);
      state.isFriendListPanelOpen = nextIsOpen;
    },    
    setFriendListPanelOpen: (state, action) => {
      closeOverlayPanels(state);
      state.isFriendListPanelOpen = Boolean(action.payload);
    },
    toggleNotificationSidebar: (state) => {
      const nextIsOpen = !state.isNotificationSidebarOpen;
      closeOverlayPanels(state);
      state.isNotificationSidebarOpen = nextIsOpen;
    },
    setNotificationSidebarOpen: (state, action) => {
      closeOverlayPanels(state);
      state.isNotificationSidebarOpen = Boolean(action.payload);
    },
    toggleCart: (state) => {
      const nextIsOpen = !state.isCartOpen;
      closeOverlayPanels(state);
      state.isCartOpen = nextIsOpen;
    },
    setCartOpen: (state, action) => {
      closeOverlayPanels(state);
      state.isCartOpen = Boolean(action.payload);
    },
    toggleWishlist: (state) => {
      const nextIsOpen = !state.isWishlistOpen;
      closeOverlayPanels(state);
      state.isWishlistOpen = nextIsOpen;
    },
    setWishlistOpen: (state, action) => {
      closeOverlayPanels(state);
      state.isWishlistOpen = Boolean(action.payload);
    },
    toggleAvatarDropdown: (state) => {
      const nextIsOpen = !state.isAvatarDropdownOpen;
      closeOverlayPanels(state);
      state.isAvatarDropdownOpen = nextIsOpen;
    },
    setAvatarDropdownOpen: (state, action) => {
      closeOverlayPanels(state);
      state.isAvatarDropdownOpen = Boolean(action.payload);
    },
    toggleWalletSidebar: (state) => { 
      const nextIsOpen = !state.isWalletSidebarOpen;
      closeOverlayPanels(state);
      state.isWalletSidebarOpen = nextIsOpen;
    },
    setWalletSidebarOpen: (state, action) => {
      const isOpen = Boolean(action.payload?.isOpen);
      const shouldToggleClosed = isOpen && state.isWalletSidebarOpen;

      closeOverlayPanels(state);

      if (shouldToggleClosed) {
        return;
      }

      state.isWalletSidebarOpen = isOpen;
    },
    toggleConsoleModal: (state) => {
      const nextIsOpen = !state.isConsoleModalOpen;
      closeOverlayPanels(state);
      state.isConsoleModalOpen = nextIsOpen;
    },
    setConsoleModalOpen: (state, action) => {
      const isOpen = Boolean(action.payload);
      closeOverlayPanels(state);
      state.isConsoleModalOpen = isOpen;
    },
  },
});

export const { 
  setMode, 
  toggleFriendListPanel, 
  setFriendListPanelOpen, 
  toggleNotificationSidebar, 
  setNotificationSidebarOpen, 
  toggleCart, 
  setCartOpen, 
  toggleWishlist, 
  setWishlistOpen,
  toggleAvatarDropdown,
  setAvatarDropdownOpen,
  toggleWalletSidebar,
  setWalletSidebarOpen,
  toggleConsoleModal,
  setConsoleModalOpen,
  toggleTopLevelDropdown,
  setTopLevelDropdownOpen,
} = uiSlice.actions;

export default uiSlice.reducer;




